import { useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Avatar from 'react-avatar';
import { getAuth } from 'firebase/auth';

// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, Typography, IconButton } from '@mui/material';
// components
import { useDispatch, useSelector } from 'react-redux';

import { capturePHEvents } from '../../analytics/posthog.analytics';
import MenuPopover from '../../components/MenuPopover';
//
import { delAllCke } from '../../helper/cookieHelper';
import { REMOVE_ORG, REMOVE_USER, RESET_STATE } from '../../redux/constants';
import { PH_LOGOUT } from '../../utils/posthog.eventNames';
import { captureGAEvents } from '../../analytics/google.analytics';
import { GAEvents } from '../../analytics/events.constants';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
export default function AccountPopover() {
  const auth = getAuth();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth.currentUser);
  const loggedInAs = useSelector((state) => state.auth.loggedInAs);
  const navigate = useNavigate();
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleLogout = async () => {
    try {
      captureGAEvents(GAEvents.logout);
      capturePHEvents(PH_LOGOUT, {
        userData: currentUser
      });
      dispatch({ type: REMOVE_USER });
      dispatch({ type: REMOVE_ORG });
      dispatch({ type: RESET_STATE });
      if (auth.currentUser) auth.signOut();
      localStorage.clear();
      delAllCke();
      navigate('/login', { replace: true });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        {/* <Avatar src={account.photoURL} alt="photoURL" /> */}
        <Avatar name={currentUser?.fullName} src={currentUser?.profileImage} round size={45} />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography
            variant="subtitle1"
            style={{ color: 'black', textDecoration: 'none' }}
            component={RouterLink}
            onClick={handleClose}
            to={loggedInAs === 'admin' ? 'dashboard/setting' : 'dashboard/account'}
            noWrap
          >
            {currentUser?.fullName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {/* {currentUser.email || ' '} */}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            id="logout_btn"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
